// extracted by mini-css-extract-plugin
module.exports = {"row":"TaskRow_row__3Ru_d","actions":"TaskRow_actions__19-la","commentCount":"TaskRow_commentCount__3E2Cy","comment":"TaskRow_comment__1L4z7","files":"TaskRow_files__1pxiS"};